// @ts-check

import React, { useState } from "react";

import { BlockStack, Modal, Text, TextField } from "@shopify/polaris";

export const AdminModal = ({
  open,
  setOpen,
}) => {
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const createNewExport = async () => {
    setLoading(true);

    return fetch("/api/admin/request-admin-access", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("data", data);
        if (data.error) {
          setError("Error");
        } else {
          setOpen(false);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      title="Admin access"
      primaryAction={{
        content: "Create export",
        onAction: createNewExport,
        loading: loading,
      }}
      secondaryActions={[
        {
          content: "Cancel",
          onAction: () => setOpen(false),
        },
      ]}
    >
      <Modal.Section>
        <BlockStack gap="300">
          <Text as="p" variant="bodyMd">Please enter the password</Text>

          {error && <Text as="p" variant="bodyMd" tone="critical">Error</Text>}

          <TextField
            label="Password"
            value={password}
            onChange={(value) => setPassword(value)}
            type="password"
            autoComplete=""
          />
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
};
